import { createSlice } from "@reduxjs/toolkit";

export const priceListSlice = createSlice({
  name: "centerProductPriceList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedCenterProductPrice: null,
    filteredRecords: 0,
    isSingleCenterProductPriceLoading: false,
    isLoading: false,
  },
  reducers: {
    setAllCenterProductPriceLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleCenterProductPriceLoadingState: (state, action) => {
      state.isSingleCenterProductPriceLoading = true;
    },
    loadAllCenterProductPrice: (state, action) => {
      const listObj = {};
      action.payload.prices.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.prices.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleCenterProductPrice: (state, action) => {
      state.selectedCenterProductPrice =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleCenterProductPriceLoading = false;
    },
  },
});

///  why this export ????
export const {
  setAllCenterProductPriceLoadingState,
  setSingleCenterProductPriceLoadingState,
  loadAllCenterProductPrice,
  loadSingleCenterProductPrice,
} = priceListSlice.actions;

export default priceListSlice.reducer;
